module.exports = __webpack_public_path__ + "static/media/currency_exchange_black_24dp.9bc91aaa.svg";